import React, { useEffect, useRef, useState } from 'react';
import cls from 'classnames';

import styles from './QrCode.scss';

const QR_CODE_IMG_URL = 'https://static.onetwotrip.com/images/marketing/qrCodes/ott-b2c.svg';

const QrCode = () => {
  const [isZoomed, setIsZoomed] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const unZoomOnScroll = () => {
      if (isZoomed) {
        setIsZoomed(false);
      }
    };

    document.addEventListener('scroll', unZoomOnScroll);
    return () => document.removeEventListener('scroll', unZoomOnScroll);
  }, [isZoomed]);

  useEffect(() => {
    const handleWindowClick = () => {
      setIsZoomed(false);
    };

    window.addEventListener('click', handleWindowClick);
    return () => window.removeEventListener('click', handleWindowClick);
  }, [containerRef]);

  const handleQRClick = (e) => {
    setIsZoomed(!isZoomed);
    e.stopPropagation();
  };

  return (
    <div ref={containerRef} className={styles.container} onClick={handleQRClick}>
      <img
        className={cls(styles.qrCodeImage, { [styles.zoomed]: isZoomed })}
        src={QR_CODE_IMG_URL}
        alt="b2c-qr-code"
      />
    </div>
  );
};

export default QrCode;
